export const compliance = {
label: 'CUMPLIMIENTO Y GOBERNANZA',
title: 'Procesos Responsables. Estándares Claros.',
subtitle: 'Procesos internos diseñados para respaldar la calidad de los productos, comunicaciones responsables, gobernanza corporativa y coordinación regulatoria específica de cada mercado.',

areas_title: 'Áreas de Cumplimiento',
area_1: 'Calidad del Producto',
area_1_desc: 'Procesos enfocados en documentación de productos, revisión de calidad e información consistente sobre los productos.',
area_2: 'Revisión Específica por Mercado',
area_2_desc: 'Los requisitos de productos y mercados se evalúan de acuerdo con la jurisdicción aplicable y el mercado previsto.',
area_3: 'Gobernanza Corporativa',
area_3_desc: 'Responsabilidades internas definidas respaldan una toma de decisiones responsable y disciplina operativa.',
area_4: 'Comunicaciones Responsables',
area_4_desc: 'Se espera que las comunicaciones corporativas y de los distribuidores sigan la información aprobada sobre productos y negocio.',

closing_statement: 'Nuestro enfoque se basa en prácticas empresariales responsables, información precisa sobre los productos, responsabilidades internas definidas y revisión específica de cada mercado. Los requisitos regulatorios pueden variar según la jurisdicción, categoría del producto y mercado previsto.',
};
